/**
 * InfoCard — 信息展示卡片（共享组件）
 *
 * 带图标标签的信息卡，用于 ClientDetail / ContactDetail / ProjectDetail 的 Overview 区域。
 * Props:
 *   icon    — lucide-react 图标组件
 *   label   — 卡片标签（小号大写）
 *   value   — 卡片值（支持字符串 / JSX）
 *   sub     — 可选副标题
 *   mono    — 可选，值使用等宽字体
 */
export default function InfoCard({ icon: Icon, label, value, sub, mono }) {
  return (
    <div className="p-3 rounded-md" style={{ background: '#f8f7f4', border: '1px solid #e5e4df' }}>
      <div className="flex items-center gap-1.5 mb-1">
        <Icon className="w-3.5 h-3.5 text-[#c9a84c]" />
        <span className="text-xs font-semibold uppercase tracking-wider text-[#6b7280]">{label}</span>
      </div>
      <div className={`text-sm font-medium text-[#1a1a2e] ${mono ? "font-mono" : ""}`}>{value}</div>
      {sub && <div className="text-xs text-[#6b7280] mt-0.5">{sub}</div>}
    </div>
  );
}
